import type { IconProps } from '../icon'
import { useEnhancedChildren } from '~/hooks/use-enhanced-children'
import { ark } from '@ark-ui/react/factory'

export type IconDualColorRootProps = Omit<
  React.ComponentPropsWithRef<'div'>,
  'className'
> &
  Pick<IconProps, 'size'> & {
    /**
     * Quando `true`, renderiza o componente como um slot via `@radix-ui/react-slot`,
     * permitindo controle externo sobre o elemento raiz.
     */
    asChild?: boolean
    /**
     * Define se o componente está desabilitado.
     * Quando `true`, o componente não pode ser interagido.
     */
    disabled?: boolean
  }

export function IconDualColorRoot({
  children,
  size = 'small',
  disabled = false,
  asChild,
  ...props
}: IconDualColorRootProps) {
  const enhancedChildrenWithInjectProps = useEnhancedChildren(children, {
    targets: ['IconDualColorTop', 'IconDualColorBottom'],
    props: {
      size,
      disabled,
    },
    asChild,
  })

  return (
    <ark.div
      data-testid="icon-dual-color-root"
      aria-label="Ícones"
      aria-disabled={disabled}
      asChild={asChild}
      {...props}
      className="relative flex [&>[data-icon=top]]:absolute"
    >
      {enhancedChildrenWithInjectProps}
    </ark.div>
  )
}

IconDualColorRoot.displayName = 'IconDualColorRoot'
